<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF BASIC
                    SCIENCES &
                    BIO-TECHNOLOGY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Physical Science</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                            <th class="time">Post Graduate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Bachelor of Science(Non-Medical)</td>
                            <td class="time">Master of Science(Physics)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Pharmacy</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Science (Non-Medical) </b>
                    – The goal of the B.Sc. Non-Medical program at the ARNI School of Basic Sciences & Bio-Technology
                    teaches non-medical disciplines like biology, chemistry, physics, computer science, and mathematics.
                    The B.Sc. Non-medical program courses give students the tools they need to succeed in their line of
                    work. The three-year course is broken up into six semesters.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> English Language</li>
                    <li> Organic & Inorganic Chemistry</li>
                    <li> Mathematical Physics</li>
                    <li> Differential Calculus, Geometry & Matrices</li>
                    <li> Regional Language</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> English Language – II</li>
                    <li> Regional Language – II</li>
                    <li> Organic Chemistry II</li>
                    <li> Integral Calculus & Theory of equations</li>
                    <li> Electricity, Magnetism, and EMT</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Thermal Physics and Statistical Mechanics</li>
                    <li> Inorganic Chemistry II</li>
                    <li> Physical Chemistry-I</li>
                    <li> Real Analysis I</li>
                    <li> Differential Equations</li>
                    <li> Language</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Wave Vibrations and Optics</li>
                    <li> Physical Chemistry-II</li>
                    <li> Organic & Inorganic Chemistry III</li>
                    <li> Electronics</li>
                    <li> Linear Algebra</li>
                    <li> Elective I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b></p>
                <ul>
                    <li> Language</li>
                    <li> Organic Chemistry-IV</li>
                    <li> Physical Chemistry-III</li>
                    <li> Numerical Analysis</li>
                    <li> Condensed Matter Physics</li>
                    <li> Elective II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b></p>
                <ul>
                    <li> Nuclear and Particle Physics</li>
                    <li> Thermal Physics and Statistical Mechanics</li>
                    <li> Wave Vibrations and Optics</li>
                    <li> Electronics</li>
                    <li> Elective III</li>
                </ul>
            </div>

            <hr class="border-dashed border-2" />

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Science (Physics) </b>
                    – The ARNI School of Basic Science & Bio-Technology offers a two-year postgraduate program called
                    MSc Physics that delves deeply into the fundamental science notion of physics. Students get the
                    ability to evaluate data and use it to solve issues. Additionally, students comprehend astrophysics,
                    quantum mechanics, and classical mechanics.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Mathematical Physics</li>
                    <li> Fundamentals of MATLAB</li>
                    <li> Quantum Mechanics I</li>
                    <li> Classical Electrodynamics I</li>
                    <li> Solid State Physics</li>
                    <li> Mathematical Physics</li>
                    <li> Labs Practical</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Quantum Mechanics II</li>
                    <li> Renewable Energy Sources</li>
                    <li> Nuclear Physics I</li>
                    <li> Solid State Physics II</li>
                    <li> Atomic Physics</li>
                    <li> Statistical Mechanics</li>
                    <li> Electronics</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Nuclear Physics – II</li>
                    <li> Computer Applications in Physics-I</li>
                    <li> Electromagnetics</li>
                    <li> Elective I</li>
                    <li> Dissertation/Thesis – 1</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Astrophysics</li>
                    <li> Molecular Spectroscopy</li>
                    <li> Computer Applications in Physics II</li>
                    <li> Elective II</li>
                    <li> Dissertation/Thesis – 2</li>
                </ul>
            </div>

        </div>


    </div>
</section>
